import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { combineLatest } from 'rxjs';
import * as ObjectUtils from 'util';
import {
  CommonService,
  EnergyService,
  PlantServiceService,
  SiteService
} from '../../../../services/index';
import {
  AppUtils,
  Constants,
  Highcharts$,
  Moment$
} from '../../../../shared/index';
import { EnergyTrendsComponent } from '../energy-trends/energy-trends.component';

@Component({
  selector: 'app-energy',
  templateUrl: './energy.component.html',
  styleUrls: ['./energy.component.scss']
})
export class EnergyComponent implements OnInit, AfterViewInit, OnDestroy {
  dateRange: any;
  alwaysShowCalendars: boolean;
  ranges: any = {
    // 'Today': [Moment$(), Moment$()],
    Yesterday: [Moment$().subtract(1, 'days'), Moment$().subtract(1, 'days')],
    'Last 7 Days': [Moment$().subtract(6, 'days'), Moment$()],
    'Last 30 Days': [Moment$().subtract(29, 'days'), Moment$()],
    'This Month': [Moment$().startOf('month'), Moment$().toDate()]
    // 'Last Month': [Moment$().subtract(1, 'month').startOf('month'), Moment$().subtract(1, 'month').endOf('month')]
  };
  totalEnergyConsumptionChart: Chart;
  energySourcingChart: Chart;
  topEnergyConsumersChart: Chart;
  demandSupplyTrendsChart: Chart;
  totalEnergyChartOption: any;
  processEnergyOption: any;
  demandSupplyTrendsChartOption: any;
  siteId: string;
  startDate: string;
  endDate: string;
  isFirstLoaded = true;
  isDateChanged = false;
  generatedTimeMsg = '';
  querySiteId: object;
  colors = ['#26b24a', '#ffe400', '#39c0ff'];
  totalEnergyConsumptionValue = 'NA';
  totalEnergySourcingValue = 'NA';
  firstShiftValue = 'NA';
  secondShiftValue = 'NA';
  nightShiftValue = 'NA';
  firstShiftSourceValue = 'NA';
  secondShiftSourceValue = 'NA';
  nightShiftSourceValue = 'NA';
  isNotViewFull = true;
  buttons: any;
  isOnViewFull = false;
  yesterdayString: String;
  energyloss = {
    supplied: '',
    loss: '',
    metered: ''
  };
  thousandSeparator: string;
  decimalSepartor: string;

  constructor(
    private energyService: EnergyService,
    private commonService: CommonService,
    private siteService: SiteService,
    private plantService: PlantServiceService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.totalEnergyChartOption = this.getTotalEnergyChartOption();
    this.processEnergyOption = this.getProcessEnergyChartOption();
    this.totalEnergyConsumptionChart = new Chart(this.totalEnergyChartOption);
    //
    this.yesterdayString = `Yesterday (${Moment$()
      .subtract(1, 'days')
      .format(Constants.MOMENT_DATE_FORMAT.DAY_FORMAT)})`;
    // Testing
    this.energySourcingChart = new Chart(this.totalEnergyChartOption);
    this.topEnergyConsumersChart = new Chart(this.processEnergyOption);
    // Testing
    this.demandSupplyTrendsChartOption =
      this.getDemandSupplyTrendsChartOption();
    this.alwaysShowCalendars = true;
    // this.dateRange = { 'startDate': '2019-07-17T07:01:39.547Z', 'endDate': '2019-07-17T07:01:39.547Z' };
    this.dateRange = {
      startDate: Moment$().subtract(1, 'days'),
      endDate: Moment$().subtract(1, 'days')
    };
    this.thousandSeparator = AppUtils.getThousandSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
    this.decimalSepartor = AppUtils.getDecimalSeparator(
      Constants.LOCALE[localStorage.getItem('siteTimezone')]
    );
  }

  ngOnInit() {
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe((routeParams) => {
      this.siteId = routeParams.siteId;
      this.querySiteId = Object.assign({}, { siteId: this.siteId });
      this.getDemandSupplyTrends();
      this.processDataAndDrawChart();
    });
  }

  ngAfterViewInit() {
    const seft = this;
    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    // document.addEventListener('resize', function () {
    window.onresize = function () {
      const dom = document.getElementById('chartContainer');
      if (seft.commonService.isNullOrUndefined(dom)) {
        return;
      }
      if (dom && dom.clientHeight > 400) {
        setTimeout(() => {
          dom.setAttribute('height', '400');
        }, 200);
      }
      if (document.fullscreenElement) {
        seft.demandSupplyTrendsChart.ref.setSize(
          document.documentElement.clientWidth,
          document.documentElement.clientHeight
        );
        seft.topEnergyConsumersChart.ref.setSize(
          document.documentElement.clientWidth,
          document.documentElement.clientHeight
        );
      } else {
        seft.demandSupplyTrendsChart.ref.setSize(
          dom.clientWidth,
          dom.clientHeight < 200 ? dom.clientHeight : 200
        );
        seft.topEnergyConsumersChart.ref.setSize(
          dom.clientWidth,
          dom.clientHeight < 200 ? dom.clientHeight : 200
        );
      }
    };
    // window.onresize = this.reportWindowSize;

    document.addEventListener('fullscreenchange', function () {
      seft.isOnViewFull = !seft.isOnViewFull;
      if (seft.demandSupplyTrendsChart.ref) {
        seft.demandSupplyTrendsChart.ref.reflow(new Event('resize'));
        // const dom = document.getElementById('demand');
        // seft.processEnergyConsumptionHCChart_Test.ref.setSize(dom.clientWidth, dom.clientHeight);

        seft.demandSupplyTrendsChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      if (seft.topEnergyConsumersChart.ref) {
        seft.topEnergyConsumersChart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }

  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', function () {});
  }

  reportWindowSize() {
    const dom = document.getElementById('chartContainer');
    this.demandSupplyTrendsChart.ref.setSize(
      dom.clientWidth,
      dom.clientHeight < 400 ? dom.clientHeight : 400
    );
  }

  datesUpdated(event) {}

  public onChangeDateRange = () => {
    if (
      Moment$(this.dateRange.endDate).diff(
        Moment$(this.dateRange.startDate),
        'days'
      ) >= 31
    ) {
      this.commonService.showDialogMessage(
        'Note: Data display limited to 31 days. Please select duration not more than 31 days'
      );
      return;
    }

    if (this.commonService.isLaterThanCurentDate(this.dateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }

    if (
      this.isFirstLoaded === false &&
      ObjectUtils.isNullOrUndefined(this.siteId) === false
    ) {
      this.processDataAndDrawChart();
    }
  };

  private processDataAndDrawChart = () => {
    const seft = this;
    this.transformDate();
    this.isFirstLoaded = false;
    this.energyService
      .getShiftwiseenergy(this.siteId, this.startDate, this.endDate)
      .subscribe((data) => {
        const chartData = [];
        let total = 0;
        if (data.data !== undefined) {
          for (let i = 0; i < data.data.length; i++) {
            total += data.data[i];
            chartData.push([data.categories[i], data.data[i]]);
          }
          if (data.data.length === 3) {
            this.firstShiftValue =
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+data.data[0]) + ' kWh';
            this.secondShiftValue =
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+data.data[1]) + ' kWh';
            this.nightShiftValue =
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+data.data[2]) + ' kWh';
          }
        }
        // tslint:disable-next-line:max-line-length
        // this.totalEnergyChartOption.subtitle.text = '<span style="color:red;font-size:16px;">' + Highcharts$.numberFormat(total, Constants.DECIMAL_FORMAT.DECIMAL_NO) + '<br>kWh</span>';
        this.totalEnergyConsumptionValue =
          new Intl.NumberFormat(
            Constants.LOCALE[localStorage.getItem('siteTimezone')],
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          ).format(+total) + ' kWh';
        this.totalEnergyChartOption.series[0].data = chartData;
        this.totalEnergyConsumptionChart = new Chart(
          this.totalEnergyChartOption
        );
        // Testing
        //this.energySourcingChart = new Chart(this.totalEnergyChartOption);
      });
    this.energyService
      .getEnergyPareto(this.siteId, this.startDate, this.endDate)
      .subscribe((data) => {
        if (ObjectUtils.isArray(data)) {
          const result = data.map((x) => [x.processName, x.energyValue]);
          // tslint:disable-next-line:max-line-length
          // const dataTest = [['Heat Treatment', 10889.919999999998], ['COMPRESSOR', 5989.58], ['Surface Treatment', 3162.3499999999995], ['SubStation(Hanger 103)', 2804.23], ['H101_SERVICE AREA', 2202.3500000000004], ['Z-Stage', 1475.19], ['Cam Plate', 1405.53], ['TMC Line 3', 1217.58]];
          this.processEnergyOption.series[0].data = result;
          this.topEnergyConsumersChart = new Chart(this.processEnergyOption);
        }
      });
    this.energyService
      .getEnergySourcingShiftWise(this.siteId, this.startDate, this.endDate)
      .subscribe((res) => {
        const chartData = [];
        let total = 0;
        if (res.data !== undefined) {
          for (let i = 0; i < res.data.length; i++) {
            total += res.data[i];
            chartData.push([res.categories[i], res.data[i]]);
          }
          if (res.data.length === 3) {
            this.firstShiftSourceValue =
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+res.data[0]) + ' kWh';
            this.secondShiftSourceValue =
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+res.data[1]) + ' kWh';
            this.nightShiftSourceValue =
              new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+res.data[2]) + ' kWh';
          }
        }

        this.totalEnergySourcingValue =
          new Intl.NumberFormat(
            Constants.LOCALE[localStorage.getItem('siteTimezone')],
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          ).format(+total) + ' kWh';
        this.totalEnergyChartOption.series[0].data = chartData;
        this.energySourcingChart = new Chart(this.totalEnergyChartOption);
      });
    this.energyService
      .getEnergyLoss(this.siteId, this.startDate, this.endDate)
      .subscribe((res) => {
        if (!ObjectUtils.isNullOrUndefined(res)) {
          seft.energyloss.loss = res.loss.toFixed(2);
          seft.energyloss.supplied = res.supplied.toFixed(2);
          seft.energyloss.metered = res.metered.toFixed(2);
        }
      });
    this.plantService.getShiftsBySiteId(this.siteId).subscribe((data) => {
      if (data.length > 0) {
        const firstShiftStart = data[0].shiftStart;
        const lastShiftEnd = data[data.length - 1].shiftEnd;
        const dayRange = Moment$(this.endDate).diff(
          Moment$(this.startDate),
          'days'
        );
        let newDate = Moment$();
        if (dayRange === 0) {
          newDate = Moment$(this.endDate).add(1, 'days');
        } else {
          newDate = Moment$(this.endDate);
        }
        this.generatedTimeMsg = `You are viewing data from
            ${Moment$(this.startDate).format(
              Constants.MOMENT_DATE_FORMAT.DAY_FORMAT
            )}
            ${Moment$(firstShiftStart).format(
              Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
            )}
            to ${Moment$(newDate).format(
              Constants.MOMENT_DATE_FORMAT.DAY_FORMAT
            )}
            ${Moment$(lastShiftEnd).format(
              Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT
            )}`;
      }
    });
  };

  getDemandSupplyTrends() {
    const startDate = Moment$().format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
    const endDate = Moment$().format(Constants.MOMENT_DATE_FORMAT.DATE_FORMAT);
    let series = [];

    this.siteService
      .getDemandSupplyTrendsChart(this.siteId, startDate, endDate)
      .subscribe((data) => {
        if (
          !ObjectUtils.isNullOrUndefined(data) &&
          ObjectUtils.isArray(data.demand) &&
          ObjectUtils.isArray(data.supply)
        ) {
          // ObjectUtils.isArray(data)
          const demandData = data.demand.map((v) => [v.x, v.y]);
          const demand = { name: 'Demand', data: demandData };
          const supplyData = data.supply.map((v) => [v.x, v.y]);
          const supply = { name: 'Supply', data: supplyData };
          if (this.siteId === 'MicrBeng560166') {
            //show only for MTC demo site
            let forecastData = [];
            forecastData = data.forecast.map((v) => [v.x, v.y]);
            let forecast = {
              data: forecastData,
              name: 'AI Forecast',
              type: 'spline',
              dashStyle: 'Dash'
            };
            series = [demand, supply, forecast];
          } else {
            series = [demand, supply];
          }

          this.demandSupplyTrendsChartOption.series = series;
          this.demandSupplyTrendsChart = new Chart(
            this.demandSupplyTrendsChartOption
          );
        }
      });
  }

  private transformDate = () => {
    this.startDate = Moment$(this.dateRange.startDate).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
    this.endDate = Moment$(this.dateRange.endDate).format(
      Constants.MOMENT_DATE_FORMAT.DATE_FORMAT
    );
  };

  // private getTotalEnergyChartOption = () => {
  //   const option = {
  //     chart : {
  //       type : 'pie',
  //     },
  //     title: {
  //       text: ''
  //     },
  //     subtitle : {
  //       text : '',
  //       align : 'center',
  //       // y : 40
  //     },
  //     tooltip : {
  //       formatter : function() {
  //         return '<b>' + this.point.name + '</b><br/><span style="color:' + this.series.points[this.point.index].color
  //             + '">\u25CF</span>   ' + this.series.name + ': '
  //             + Highcharts$.numberFormat(this.y, Constants.DECIMAL_FORMAT.DECIMAL_NO) + ' kWh ('
  //             + Highcharts$.numberFormat(this.percentage, Constants.DECIMAL_FORMAT.DECIMAL_NO) + ' %)';
  //       }
  //     },
  //     plotOptions : {
  //       column : {
  //         stacking : 'normal',
  //         dataLabels : {
  //           enabled : false,
  //           color : 'grey',
  //           style : {
  //             /*textShadow : '0 0 3px black'*/
  //           },
  //           formatter: function () {
  //                           return Highcharts$.numberFormat(this.y, Constants.DECIMAL_FORMAT.DECIMAL_NO);
  //                       }
  //         }
  //       }
  //     },
  //     credits : {
  //       enabled : false
  //     },
  //     colors: ['#7CB5EC', '#90ED7D', '#7F7F7F'],
  //     series : [ {
  //       name : 'Energy',
  //       data : []
  //     } ]
  //   };
  //   return option;
  // }

  // New REQ
  private getTotalEnergyChartOption = () => {
    const self = this;
    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const option = {
      chart: {
        type: 'pie',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '80%'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.point.name +
            '</b><br/><span style="color:' +
            this.series.points[this.point.index].color +
            '">\u25CF</span>   ' +
            this.series.name +
            ': <b>' +
            new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.y) +
            ' kWh (' +
            new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.percentage) +
            ' %)</b>'
          );
        }
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -20,
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return (
                new Intl.NumberFormat(
                  Constants.LOCALE[localStorage.getItem('siteTimezone')],
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }
                ).format(+this.point.percentage) + ' %'
              );
            }
          },
          startAngle: -180,
          endAngle: 180,
          // center: ['50%', '75%'],
          size: '100%',
          showInLegend: false
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      // colors: ['#7CB5EC', '#90ED7D', '#7F7F7F'],
      colors: this.colors,
      // legend: {
      //   layout: 'vertical',
      //   align: 'right',
      //   verticalAlign: 'middle',
      //   itemMarginTop: 10,
      //   itemMarginBottom: 10
      // },
      series: [
        {
          type: 'pie',
          name: 'Energy',
          innerSize: '60%',
          data: []
        }
      ]
    };
    return option;
  };

  private getProcessEnergyChartOption = () => {
    const self = this;
    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const option = {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: '',
        align: 'center'
        // y : 40
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Energy pareto (kWh)'
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: 'gray'
          },
          formatter: function () {
            return new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.axis.series[0].yData[this.x]);
          }
        }
      },
      legend: {
        enabled: true
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
            color: 'grey',
            style: {
              /*textShadow : '0 0 3px black'*/
            },
            formatter: function () {
              return new Intl.NumberFormat(
                Constants.LOCALE[localStorage.getItem('siteTimezone')],
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(+this.y);
            }
          }
        }
      },
      tooltip: {
        formatter: function () {
          let dataSum = 0;
          const seriesData = this.series.data;
          for (let i = 0; i < seriesData.length; i++) {
            dataSum += seriesData[i].y;
          }
          const pcnt = (this.y / dataSum) * 100;
          // tslint:disable-next-line:max-line-length
          return (
            '<b>' +
            this.key +
            '</b><br/>' +
            new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+pcnt) +
            ' %<br/>' +
            new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.y) +
            ' kWh'
          );
        }
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: 'Process Energy Consumption',
          data: []
        }
      ]
    };
    return option;
  };

  private getDemandSupplyTrendsChartOption = () => {
    const self = this;
    Highcharts$.setOptions({
      lang: {
        decimalPoint: self.decimalSepartor,
        thousandsSep: self.thousandSeparator
      }
    });
    const option = {
      chart: {
        type: 'spline'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      navigator: {
        enabled: true
      },
      xAxis: {
        type: 'datetime',
        labels: {
          autoRotation: [-45],
          formatter: function () {
            return self.commonService
              .getFormattedDate(
                localStorage.getItem('siteTimezone'),
                this.value
              )
              .format(Constants.MOMENT_DATE_FORMAT.HOURS_FORMAT);
          }
        },
        crosshair: true
      },
      yAxis: {
        title: {
          text: 'kW'
        },
        labels: {
          formatter: function () {
            return new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.value);
          }
        },
        lineWidth: 2,
        min: 0
      },
      legend: {
        enabled: true
      },
      tooltip: {
        formatter: function () {
          return (
            '<b>' +
            this.series.name +
            '</b><br/>' +
            self.commonService
              .getFormattedDate(
                localStorage.getItem('siteTimezone'),
                this.point.x
              )
              .format(Constants.MOMENT_DATE_FORMAT.FULL_DATE_TIME_FORMAT) +
            ' : <b>' +
            new Intl.NumberFormat(
              Constants.LOCALE[localStorage.getItem('siteTimezone')],
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }
            ).format(+this.point.y) +
            ' kW</b>'
          );
        }
      },
      plotOptions: {
        spline: {
          marker: {
            enable: true
          }
        }
      },
      series: []
    };
    return option;
  };

  onEnergyTrendClick() {
    const dialogRef = this.dialog.open(EnergyTrendsComponent, {
      width: '88%',
      maxHeight: '820px'
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.data) {
      }
    });
  }
}
